<script setup lang="ts">
  import { useSidebar } from './sidebar-provider.vue'

  const { isRail } = useSidebar()

  const props = defineProps<{
    title?: string
    description?: string
  }>()
</script>
<template>
  <div
    class="flex min-h-[88px] items-center"
    :class="{ 'p-5': !isRail, 'p-1': isRail }"
  >
    <slot>
      <div class="flex flex-col" v-if="props.title || props.description">
        <div class="text-base font-medium leading-normal" v-if="props.title">
          {{ props.title }}
        </div>
        <div class="text-soft text-sm leading-normal" v-if="props.description">
          {{ props.description }}
        </div>
      </div>
    </slot>
  </div>
  <div class="px-5">
    <div
      role="separator"
      class="before:bg-border transition-all-default relative flex h-0 w-full items-center before:absolute before:left-0 before:top-1/2 before:h-px before:w-full before:-translate-y-1/2"
    ></div>
  </div>
</template>
